import NewDealerForm from "components/Forms/DealerForm/NewDealerForm";

const NieuweDealer = () => {
  return <NewDealerForm />;
};

export default NieuweDealer;
